"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMobileOperatingSystem = void 0;
const useMobileOperatingSystem = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /(android)/i.test(navigator.userAgent);
  return {
    isMobileOperatingSystem: isIOS || isAndroid
  };
};
exports.useMobileOperatingSystem = useMobileOperatingSystem;